import HttpClient from './newHttp'

const RESOURCES_CACHE_MS = 300_000

class ResourcesClient extends HttpClient {
  constructor() {
    super('', RESOURCES_CACHE_MS)
  }

  async getResources(params = {}) {
    const { data } = await this.http.get('api/get_resource_data', { params })
    return data
  }
}

class CustomListClient extends HttpClient {
  constructor() {
    super('', RESOURCES_CACHE_MS)
  }

  async getList(url, params = {}) {
    const { data } = await this.http.get(url, { params })
    return data
  }
}

class UserClient extends HttpClient {
  constructor() {
    super('')
  }

  async updateUser(requestData) {
    const { data } = await this.http.put('/api/my-user', new URLSearchParams(requestData), {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    })
    return data
  }
}

class CompanyClient extends HttpClient {
  constructor() {
    super('')
  }

  async updateCompany(formData, id) {
    const uri = `/api/companies/${String(id)}`
    const { data } = await this.http.post(uri, formData)
    return data
  }
}

export const resourcesHTTP = new ResourcesClient()
export const customClientHTTP = new CustomListClient()
export const userClientHTTP = new UserClient()
export const companyClientHTTP = new CompanyClient()
